import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "design",
  id: "design"
}
const _hoisted_2 = { class: "container content-section" }
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "col-12 col-md-6 feature-image" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-6\"><div class=\"feature-box\"><h2 class=\"title\">Thinking mobile first</h2><p class=\"action-text\"> We used to say ‘if you don’t have a website you do not exist’, nowadays we should be saying: if your site isn’t accessible on mobile devices you do not exist. </p><p class=\"action-text\"> At Mobilem we set mobile accessibility as our top priority. All our projects feature cutting edge responsive web design or a mobile application. Mobile is the future now, light, quick and contextual in the palm of your hands. </p><a href=\"#contact\" class=\"btn normal\">Learn More</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: require('@/assets/img/showcase2.jpg'),
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5
      ])
    ])
  ]))
}